module.exports = __webpack_public_path__ + "img/startIcon.d1050e3b.png";